import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';

@Injectable()
export class TestHttpInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log('intercepted request ... ');
    // console.log(req);

    // Quick hack to fix login error. EAI is looking for the data key...
    req['data'] = req.body;

    // send the newly created request
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/interceptor.ts